import React from 'react'
import BlogSection from '../component/Blog/BlogSection'
import Layout from '../component/Layout/Layout'
import ContentHeader from './ContentHeader'

export default function Blog() {
  return (
    <div id="BLOG">
      <Layout>
        <ContentHeader name={'My Article'} />
        <BlogSection />
      </Layout>
    </div>
  )
}
